import * as R from 'remeda';
import { User } from '@rossum/api-client/users';
import { SCHEMA_COLUMN_PREFIX } from '../document-list-base/schemaColumnPrefix';
import { FilterOperator } from '../mql/operators';
import { ValueOptions } from './types';

const sortValueOptions = (valueOptions: ValueOptions) =>
  valueOptions.sort((a, b) => a.label.localeCompare(b.label));

export const getModifierValueOptions = (modifiers: User[]) =>
  sortValueOptions(
    modifiers.map(modifier => {
      const { id, email, username } = modifier;

      return {
        value: `${id}`,
        label: email || username,
      };
    })
  );

export const retrieveSchemaColumnName = (value: string) =>
  value.startsWith(`${SCHEMA_COLUMN_PREFIX}.`)
    ? R.first(value.replace(`${SCHEMA_COLUMN_PREFIX}.`, '').split('.'))
    : null;

// this function is onyl to restrict the union type of filter operator properties
// so when we use a combination of containers.filtering.operators.{type}.{value} TS does not complain

export const getOperatorLocalisationKey = (op: FilterOperator) => {
  if (op.type === 'string') return `${op.type}.${op.value}` as const;
  if (op.type === 'multiSelect') return `${op.type}.${op.value}` as const;
  if (op.type === 'date') return `${op.type}.${op.value}` as const;
  if (op.type === 'number') return `${op.type}.${op.value}` as const;

  return null;
};
